import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Sophia_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Sophia_Renters/video.jpg';

export const Sophia: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Sophia',
  videoUrl: `${ASSETS_URL}/renters/Sophia_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
  displayInHomePage: true,
};
